import { Type } from 'class-transformer'
import { AuthState } from '@/constants/constants'
import { OwnerProfileDto } from '@/dtos/auth/common'

/**
 * ログインリクエスト送信用リクエスト
 * @param encryptedTransitionTo 暗号化したログイン後の遷移先
 * @param isWeb Web利用かどうか
 * @param authZCode 認可コード ⇒ 本番時のみ使用。mock利用時はundefined
 * @param emailAddress メールアドレス ⇒ mock利用時のみ使用。本番時はundefined
 */
export class LoginPostRequest {
  encryptedTransitionTo: string
  isWeb: boolean
  authZCode?: string
  emailAddress?: string

  constructor(encryptedTransitionTo: string, isWeb: boolean, authZCode?: string, emailAddress?: string) {
    this.encryptedTransitionTo = encryptedTransitionTo
    this.isWeb = isWeb
    this.authZCode = authZCode
    this.emailAddress = emailAddress
  }

  static withAuthZCode(encryptedTransitionTo: string, isWeb: boolean, authZCode: string): LoginPostRequest {
    return new LoginPostRequest(encryptedTransitionTo, isWeb, authZCode, undefined)
  }

  static withEmailAddress(encryptedTransitionTo: string, isWeb: boolean, emailAddress: string): LoginPostRequest {
    return new LoginPostRequest(encryptedTransitionTo, isWeb, undefined, emailAddress)
  }
}

export class LoginPostResponse {
  authState?: AuthState
  @Type(() => OwnerProfileDto) profile?: OwnerProfileDto
  failedMessage?: string
  transitionTo?: string
  csrfToken?: string
  redirectTo?: string
}
